import {
  AuthMethodEnum,
  CreateSessionRequestEnum,
  CreateSessionResponseEnum,
} from "@b2bportal/auth-api";
import { trackEvent } from "@hopper-b2b/api";
import { createSession } from "../../api";
import {
  AuthTrackingEvents,
  type VerifyFailureEvent,
  type VerifySuccessEvent,
} from "../../types/tracking";
import type { AuthMachineContext } from "../context";
import type { VerifyCodeEvent } from "../events";
import { getAuthStateToken } from "../selectors";

export const verifyCodeService = (
  context: AuthMachineContext,
  event: VerifyCodeEvent
) =>
  new Promise((resolve, reject) => {
    const authStateToken = getAuthStateToken({ context }) as string;
    const trackFailure = () =>
      trackEvent({
        eventName: AuthTrackingEvents.VerifyFailure,
        properties: {
          auth_type: event.auth_type,
        },
      } as VerifyFailureEvent);

    createSession({
      authMethod: {
        authStateToken: authStateToken,
        code: event.code,
        AuthMethod: AuthMethodEnum.VerifyCode,
      },
      CreateSessionRequest: CreateSessionRequestEnum.SignIn,
    })
      .then((res) => {
        if (
          res.CreateSessionResponse ===
          CreateSessionResponseEnum.CreateSessionFailed
        ) {
          trackFailure();
          reject(res.reason);
        } else {
          trackEvent({
            eventName: AuthTrackingEvents.VerifySuccess,
            properties: {
              auth_type: event.auth_type,
            },
          } as VerifySuccessEvent);
          resolve(res);
        }
      })
      .catch((error) => {
        trackFailure();
        reject(error);
      });
  });
